import styles from './score-ring.module.css';

interface ScoreRingProps {
  score: number;
  maxScore: number;
  size?: number;
  strokeWidth?: number;
}

export function ScoreRing({
  score,
  maxScore,
  size = 120,
  strokeWidth = 10,
}: ScoreRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const percentage = maxScore > 0 ? score / maxScore : 0;
  const dashOffset = circumference * (1 - percentage);

  return (
    <div className={styles.ring} style={{ width: size, height: size }}>
      <svg width={size} height={size} className={styles.svg}>
        <circle
          className={styles.track}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <circle
          className={styles.progress}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
        />
      </svg>
      <div className={styles.label}>
        <span className={styles.score}>{Math.round(score)}</span>
        <span className={styles.max}>/{maxScore}</span>
      </div>
    </div>
  );
}
